import { MUI_X_LICENSE_KEY } from '../constants';
import { LicenseInfo } from '@mui/x-license';

if (MUI_X_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(MUI_X_LICENSE_KEY);
} else {
  console.warn("MUI_X_LICENSE_KEY is not defined");
}

export default function MuiXLicense() {
  return null;
}

